import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAccessToken, getRefreshToken, setTokens, clearTokens } from '../utils/auth';
import { logoutUser } from '../store/slices/authSlice';
import { AppDispatch } from '../store';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

export const useTokenRefresh = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const checkAndRefreshToken = async () => {
      const accessToken = getAccessToken();
      const refreshToken = getRefreshToken();

      if (!accessToken || !refreshToken) return;

      try {
        // Check if token will expire in the next 5 minutes
        const decoded = JSON.parse(atob(accessToken.split('.')[1]));
        const expirationTime = decoded.exp * 1000;
        const currentTime = Date.now();
        const timeUntilExpiry = expirationTime - currentTime;

        // If token expires in less than 5 minutes, refresh it
        if (timeUntilExpiry < 5 * 60 * 1000) {
          const response = await axios.post(`${API_URL}/token/refresh`, {
            refresh_token: refreshToken,
          });

          const { access_token, refresh_token } = response.data;
          setTokens(access_token, refresh_token);
        }
      } catch (error) {
        console.error('Token refresh failed:', error);
        clearTokens();
        dispatch(logoutUser());
      }
    };

    // Check token immediately
    checkAndRefreshToken();

    // Set up interval to check every minute
    const interval = setInterval(checkAndRefreshToken, 60 * 1000);

    return () => clearInterval(interval);
  }, [dispatch]);
};